module.exports = __webpack_public_path__ + "static/media/createcircle.ec62c0e8.png";